<template>
  <v-row dense justify="center">
    <v-col cols="12">
      <v-card class="fill-height">
        <v-card-title>
          <v-icon color="secondary" left>mdi-chart-timeline-variant</v-icon> Aproveitamento <template v-if="form.subjects !== null">{{ form.course }}</template>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th colspan="2" class="text-center">Disciplinas</th>
                  <th class="text-center" v-for="(topic, index) in form.data" :key="index">{{ topic.name }}</th>
                </tr>
              </thead>
              <tbody v-if="form.subjects && (form.levels > 1)" v-html="tableRows"></tbody>
              <tbody v-if="form.subjects && (form.levels === 1)">
                <tr v-for="(subject, key, index) in form.subjects" :key="index">
                  <td style="border-bottom: none;">{{ subject }}</td>
                  <td v-for="(topic, index) in form.data" :key="index">
                    <template v-if="topic.subjects">
                      {{ getGradeRounded(topic.subjects[key]) }}
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Course } from '@/services/resources'

export default {
  props: [
    'matriculaId'
  ],
  data () {
    return {
      form: {
        data: {},
        levels: 0,
        subjects: {},
        course: ''
      }
    }
  },
  mounted () {
    // Carrega a estrutura do quadro de notas
    this.loadEnrollmentGrade()
  },
  computed: {
    tableRows: {
      get () {
        let r = ''
        if (this.form.levels > 1) {
          Object.keys(this.form.subjects).forEach((key) => {
            let count = 0
            Object.keys(this.form.subjects[key].subdisciplines).forEach((subkey) => {
              r += '<tr>'
              r += count === 0 ? '<td style="border-bottom: none;" rowspan="' + this.getRowSpanSize(this.form.subjects[key]) + '">' + this.form.subjects[key].name + '</td>' : ''
              r += '<td align="left">' + this.form.subjects[key].subdisciplines[subkey] + '</td>'
              Object.values(this.form.data).forEach((topic) => {
                r += '<td align="center">'
                r += topic.subjects ? '<div>' + this.getGradeRounded(topic.subjects[subkey]) + '</div>' : '<div>-</div>'
                r += '</td>'
              })
              r += '</tr>'
              count += 1
            })
          })
        }
        return r
      }
    }
  },
  methods: {
    /**
     * Carrega as informações da grade de notas de acordo com o ID da
     * matrícula do aluno
     */
    loadEnrollmentGrade () {
      Course.getEnrollmentGrade(this.matriculaId)
        .then((response) => {
          this.$set(this.form, 'subjects', response.body.subjects)
          this.form.data = { ...response.body.data }
          this.form.levels = response.body.levels
          this.form.course = response.body.course
        })
        .catch((error) => {
          if (typeof error.body.message !== 'undefined') {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    /**
     * Recebe uma disciplina e retorna quantas subdisciplinas
     * esta possui
     *
     * @param subject objeto que representa uma disciplina
     */
    getRowSpanSize (subject) {
      let size = 1
      if (subject.subdisciplines && Object.keys(subject.subdisciplines).length > 0) {
        size = Object.keys(subject.subdisciplines).length
      }

      return size
    },
    /**
     * Recebe uma disciplina como parâmetro e calcula sua média arredondada
     * em duas casas
     *
     * @param subject objeto que representa uma disciplina
     */
    getGradeRounded (subject) {
      if (typeof subject !== 'undefined') {
        return Math.round((subject.grade / subject.count) * 100) / 100
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-grades {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;

    th, td {
      border: 1px solid #ccc;
    }

    tbody tr:nth-child(odd) {
      background: #f5f5f5;
    }
  }

  .page-title {
    font-weight: bold;
    font-size: 24px;
  }

  .page-subtitle {
    font-weight: bold;
    font-size: 14px;
    color: rgb(114, 112, 112);
  }
</style>
